import { Flex, Spinner, Button, useDisclosure } from "@chakra-ui/react";
import { AccountPermission } from "@syla/shared/types/models/AccountAccessBase";
import React from "react";
import { FaBomb } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";
import { DeleteAccountModal } from "../../components/organisms/accounts/DeleteAccountModal";
import { isProduction } from "../../helper/environment";
import { hasAccountPermission } from "../../helper/permissions";
import { useCurrentAccountStore } from "../../store/currentAccountStore";
import { useQueryGetAccount } from "../../store/useQueryGetAccount";
import { Account } from "../../types/Account";
import { SettingRowBase } from "./components/SettingRowBase";
import {
  SectionHeader,
  SectionContainer,
  SettingsStack,
} from "./components/SettingsComponents";
import { ResetAccountModal } from "./ResetAccountModal";

export function AccountOtherSettings() {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const queryGetAccount = useQueryGetAccount(accountId);

  const isLoading = queryGetAccount.isLoading || !queryGetAccount.data;

  return (
    <SectionContainer>
      <SectionHeader title="Other settings" />
      {isLoading ?
        <Flex justifyContent="center" my="40px">
          <Spinner />
        </Flex>
      : <SettingsStack>
          {!isProduction() && (
            <ResetAccountSettingRow account={queryGetAccount.data} />
          )}
          {hasAccountPermission(
            queryGetAccount.data,
            AccountPermission.DeleteAccount,
          ) && <DeleteAccountSettingRow account={queryGetAccount.data} />}
        </SettingsStack>
      }
    </SectionContainer>
  );
}

function ResetAccountSettingRow({ account }: { account: Account }) {
  const disclosure = useDisclosure();

  return (
    <>
      <SettingRowBase
        label="Reset account"
        description="Reset the entire account removing all data sources, transactions , etc. This is only used during testing."
      >
        <Button
          colorScheme="red"
          leftIcon={<FaBomb />}
          onClick={disclosure.onOpen}
        >
          Reset account
        </Button>
      </SettingRowBase>
      {disclosure.isOpen && (
        <ResetAccountModal account={account} disclosure={disclosure} />
      )}
    </>
  );
}

function DeleteAccountSettingRow({ account }: { account: Account }) {
  const disclosure = useDisclosure();

  return (
    <>
      <SettingRowBase
        label="Delete account"
        description="This deletes all the data for this account, including exchanges, wallets, transactions and trade history. Any active subscriptions will also be terminated. This action is irreversible."
      >
        <Button
          colorScheme="red"
          onClick={disclosure.onOpen}
          leftIcon={<FiTrash2 />}
        >
          Delete account
        </Button>
      </SettingRowBase>
      {disclosure.isOpen && (
        <DeleteAccountModal account={account} disclosure={disclosure} />
      )}
    </>
  );
}
